import { getSourceTypeTemplate } from "@common/constants/history-source-types";
import { APIProcessName } from "@common/constants/process-names";
import { ResourceType } from "@common/types/auditLog";
import { pluralizeWithCount } from "@common/helpers/string";
import { HistoryRow } from "../views/historyViewConfig";
import { ActivityDescriptionParts } from "./activityDescriptionTypes";

// CoA template applies carry event-specific copy that cannot use the generic
// count-based formatter. Applied rows remain immutable; Reverted copy belongs
// only to grouped undo-action rows.
export function getCoaTemplateApplyDescriptionParts(
    row: HistoryRow,
): ActivityDescriptionParts | undefined {
    if (row.resourceType !== ResourceType.chartOfAccountsTemplateApplyEvent) {
        return undefined;
    }

    const template = getSourceTypeTemplate(
        row.sourceType,
        row.resourceType,
        row.fields,
    );
    if (!template) {
        return undefined;
    }

    if (
        row.sourceType === APIProcessName.CHART_OF_ACCOUNTS_TEMPLATE_APPLY ||
        row.sourceType === APIProcessName.CHART_OF_ACCOUNTS_TEMPLATE_APPLY_UNDO
    ) {
        const presentation = row.historyItem.presentation;
        const coaPresentation =
            presentation?.kind === "coaTemplateApply"
                ? presentation
                : undefined;
        const templateName = coaPresentation?.templateName ?? "";
        const entityCount =
            coaPresentation && coaPresentation.eventRefs.length > 0
                ? coaPresentation.eventRefs.length
                : row.count;
        const entityLabel = pluralizeWithCount("entity", entityCount);
        return {
            prefix: templateName
                ? `${template.verb} ${template.noun} "${templateName}"`
                : `${template.verb} ${template.noun}`,
            counter:
                row.sourceType ===
                APIProcessName.CHART_OF_ACCOUNTS_TEMPLATE_APPLY
                    ? `to ${entityLabel}`
                    : `for ${entityLabel}`,
            suffix: "",
        };
    }

    if (
        row.sourceType === APIProcessName.ORGANIZATION_CREATE_CLIENT ||
        row.sourceType === APIProcessName.ENTITY_CREATE
    ) {
        return {
            prefix: [template.verb, template.noun, template.suffix]
                .filter(Boolean)
                .join(" "),
            counter: "",
            suffix: "",
        };
    }

    return undefined;
}
